import React, { useEffect } from 'react';
import { fetcher } from 'api/client';
import { useParams, useHistory } from 'react-router-dom'
import { redirectRoute } from 'api/actions/redirect';

export default function Redirect() {
    const history = useHistory();
    const { url } = useParams();

    useEffect(() => {
        if (!url) history.push('/login')
        fetcher(redirectRoute(url))
            .then((data) => {
                if (data?.originalUrl) window.location.replace(data.originalUrl)
                else history.push('/login')
            })
            .catch(() => {
                history.push('/login')
            });
    }, [history, url])

    return <div></div>;
}